<div class="d-none d-md-block table-container">
  <app-list-view-toolbar
    [columns]="columns"
    [isSticky]="isToolbarSticky"
    [columnDefinition]="columnDefinition"
    [preferencesKey]="preferencesKey"
  >
    <div toolbar-scroll class="toolbar-horizontal-scroll" #toolbarScrollView (scroll)="onToolbarScroll()">
      <div class="toolbar-horizontal-scroll-content" #toolbarScrollContent></div>
    </div>
  </app-list-view-toolbar>
  <div class="scroll-x scroll-x-shadows" #scrollView (scroll)="onTableScroll()">
    <table class="table table-hover" #tableView>
      <thead>
        <tr>
          <th class="counter">&nbsp;#</th>
          @for (column of selectedColumns; track column) {
            @if (column.helpText) {
              <th
                [dh-list-view-header]="column.id"
                [canSort]="column.canSort"
                appTooltip="{{ column.helpText | translate }}"
                tooltipPosition="below"
                (stateChange)="onStateChange($event)"
                >
                <span class="column-caption">{{ column.caption | translate }}</span>
              </th>
            }
            @if (!column.helpText) {
              <th [dh-list-view-header]="column.id" [canSort]="column.canSort" (stateChange)="onStateChange($event)">
                <span class="column-caption">{{ column.caption | translate }}</span>
              </th>
            }
          }
          <th class="column-header"></th>
        </tr>
      </thead>
      <tbody class="table-striped">
        @for (row of desktopRows; track row; let i = $index) {
          <tr appListViewItem [class.highlight]="row.highlight" [appScrollToRecent]="row.highlight">
            <td>
              <span>{{ getRowNumber(i) }}</span>
            </td>
            @for (column of selectedColumns; track column) {
              <td (click)="onRowClicked(row, $event)">
                <dh-custom-view
                  [viewType]="column.viewType"
                  [value]="row.getValue(column)"
                  [helpText]="row.getHelpText(column)"
                  [isPhoneNumber]="column.isPhoneNumber"
                ></dh-custom-view>
              </td>
            }
            @if (!hasInlineContextMenu) {
              <td></td>
            }
            @if (hasContextMenu) {
              <app-context-menu
                [context]="row.dataSource"
                [smaller]="true"
                [menuDefinition]="contextMenuDefinition"
                [contextId]="contextId"
              ></app-context-menu>
            }
            @if (hasInlineContextMenu) {
              <td>
                <app-context-menu-inline [context]="row.dataSource" [menuDefinition]="contextMenuDefinition" [contextId]="contextId"></app-context-menu-inline>
              </td>
            }
          </tr>
        }
        <tr class="list-summary">
          <td class="counter" title="{{ 'COMMON.COUNT' | translate }}">{{ totalCount }}</td>
          @for (column of selectedColumns; track column) {
            <td>
              @if (column.sum) {
                @for (summary of sumValues(column); track $index) {
                  <div>{{ summary.displayValue }}</div>
                }
              }
            </td>
          }
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
  @if (pagingEnabled) {
    <app-paging
      [itemsPerPage]="pageSize"
      [resetOnTotalCountChange]="!rememberPagination"
      [totalCount]="totalCount"
      [pageNumber]="currentPageNumber"
      [pageSizeOptions]="pageSizeOptions"
      (onPageChange)="pagingChanged($event)"
    ></app-paging>
  }
</div>
<div class="d-block d-md-none">
  @if (rows.length > 0) {
    <app-list-view-toolbar
      [isSticky]="isToolbarSticky"
      [columns]="columns"
      [columnDefinition]="columnDefinition"
      [preferencesKey]="preferencesKey"
    ></app-list-view-toolbar>
  }
  @if (isEmpty) {
    <p class="help-text">{{ 'COMMON.EMPTY_LIST' | translate }}</p>
  }
  @for (row of rows; track row) {
    <div class="entry-m" [class.highlight]="row.highlight" [appScrollToRecent]="row.highlight">
      @if (hasContextMenu) {
        <div class="float-right">
          <app-context-menu [context]="row.dataSource" [menuDefinition]="contextMenuDefinition" [alwaysVisible]="true" [contextId]="contextId"></app-context-menu>
        </div>
      }
      <ul class="mobile-list-view" (click)="onRowClicked(row, $event)">
        @for (column of selectedColumns; track column) {
          @if (row.getValue(column)) {
            <li>
              <div class="property-name-m">{{ column.caption | translate }}</div>
              <dh-custom-view
                [viewType]="column.viewType"
                [value]="row.getValue(column)"
                [helpText]="row.getHelpText(column)"
                [isPhoneNumber]="column.isPhoneNumber"
              ></dh-custom-view>
            </li>
          }
        }
      </ul>
    </div>
  }
</div>
